<div class="options">
  <div class="select-options" *ngIf="!isImageIconSelection">
    <p class="select-statement">{{ getSelectStatementString(min, max) }}</p>
  </div>
  <div class="diamond-answer-widget" *ngIf="isWordlist">
    <ng-container *ngFor="let optionRow of optionRows">
      <div
        class="diamond-row"
        [ngClass]="{
          'word-list-top-row': optionRow.length < endRow1 && optionRow.length % 2 !== 0,
          'two-diamond-top-row': optionRow.length < endRow1 && optionRow.length % 2 === 0
        }">
        <kp-diamond
          *ngFor="let option of optionRow | slice : startRow1 : endRow1"
          [text]="option.text"
          [isSelected]="option.isSelected"
          [isDisabled]="!isLessThanMax() && max !== 1"
          [appearDisabled]="!isLessThanMax() && !option.isSelected"
          (click)="onSelect(option)"></kp-diamond>
      </div>
      <div
        class="diamond-row"
        [ngClass]="{ 'word-list-bottom-row': optionRow.length < endRow2 && optionRow.length % 2 === 0 }"
        *ngIf="optionRow[startRow2] != null">
        <kp-diamond
          *ngFor="let option of optionRow | slice : startRow2 : endRow2"
          [text]="option.text"
          [isSelected]="option.isSelected"
          [isDisabled]="!isLessThanMax() && max !== 1"
          [appearDisabled]="!isLessThanMax() && !option.isSelected"
          (click)="onSelect(option)"></kp-diamond>
      </div>
    </ng-container>
  </div>

  <div
    class="wordlist-icon-states"
    [ngClass]="isExpanded ? 'is-expanded' : rowsToShow > 0 ? 'rows-' + rowsToShow : ''"
    *ngIf="showIconStates">
    <kp-image-icon
      class="wordlist-icon-item"
      *ngFor="let option of displayOptions"
      [showTextUnderImage]="isImageWordList || isImageTile"
      [option]="option"
      [isSelected]="option.isSelected"
      [isDisabled]="!isLessThanMax() && max !== 1"
      [questionType]="questionType"
      [appearDisabled]="!isLessThanMax() && !option.isSelected"
      (imageAnswer)="onSelect(option)"></kp-image-icon>
  </div>
  <button
    class="button button-pill button-secondary"
    *ngIf="isImageWordList && !isExpanded && displayOptions?.length > minOptions"
    (click)="isExpanded = true">
    Show all
    <svg-icon class="dropdown-arrow" src="/assets/icons/chevron-right-nocircle.svg"></svg-icon>
  </button>
</div>
